import { createSelector } from '@ngrx/store';

import { menuFlowImagesState } from '../root';

export const getImageForMenuFlow = (menuFlowId: number) =>
    createSelector(menuFlowImagesState, (menuFlowImages) => menuFlowImages.find((image) => image.MenuFlowId === menuFlowId) || null);
